<script setup>
import { ref } from 'vue';
import { useStore } from 'vuex';
import getAuthClient from '@/connectors/authClient';

const store = useStore();

const signInDomain = ref('');
const errorMessage = ref('');
const obtainingSignInUrl = ref(false);

async function login() {
  obtainingSignInUrl.value = true;
  try {
    store.commit('users/setSignInDomain', signInDomain.value);
    const authClient = getAuthClient(signInDomain.value);
    const url = await authClient.getSigninUrl(process.env.VUE_APP_APP_ID);
    window.location.href = url;
  } catch (error) {
    errorMessage.value = error.message;
    obtainingSignInUrl.value = false;
  }
}
</script>

<template>
  <section class="flex w-full flex-grow flex-col items-center justify-center">
    <img src="@/assets/images/atlatl.png" alt="ATLATL" height="160" class="mb-6 h-28" />
    <form
      name="domain-prompt"
      class="flex flex-col justify-center rounded-sm bg-white p-10 shadow-lg"
      @submit.prevent="login"
    >
      <label class="mb-10 flex flex-col justify-center">
        <div
          v-show="!!errorMessage"
          class="relative mb-4 rounded border border-red-400 bg-red-100 px-3 py-2 text-red-700"
          role="alert"
        >
          <strong class="font-bold">Error: </strong>
          <span class="block sm:inline">{{ errorMessage }}</span>
        </div>
        <span class="my-2 text-xs font-bold"> Enter the domain* </span>
        <input
          id="sign-in-domain"
          v-model="signInDomain"
          type="text"
          name="sign-in-domain"
          required
          class="outline-none rounded-md bg-gray-100 p-3"
        />
      </label>

      <input type="submit" value="Proceed to Login" :disabled="obtainingSignInUrl" class="" />
    </form>
  </section>
</template>

<style lang="postcss" scope>
input[type='submit'] {
  @apply cursor-pointer rounded-lg bg-brand-700 p-4 text-white hover:bg-gray-500;
}
input[type='submit']:disabled {
  @apply cursor-not-allowed opacity-25;
}
</style>
